/* src/app/shared/components/button-loader/button-loader.component.css */
.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #0bafd4;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=button-loader.component.css.map */
